import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import infoStyle from '../../assets/jss/material-kit-react/components/infoStyle';
function InfoArea({ ...props }) {
    const { classes, title, description, iconColor, vertical, img } = props;
    const iconWrapper = classNames({
        [classes.iconWrapper]: true,
        [classes[iconColor]]: true,
        [classes.iconWrapperVertical]: vertical,
    });
    const iconClasses = classNames({
        [classes.icon]: true,
        [classes.iconVertical]: vertical,
    });
    return (React.createElement("div", { className: classes.infoArea },
        React.createElement("div", { className: iconWrapper }, img ? React.createElement("div", null, img) : React.createElement(props.icon, { className: iconClasses })),
        React.createElement("div", { className: classes.descriptionWrapper },
            React.createElement("h4", { className: classes.title }, title),
            React.createElement("p", { className: classes.description }, description))));
}
InfoArea.defaultProps = {
    iconColor: 'gray',
};
InfoArea.propTypes = {
    classes: PropTypes.object.isRequired,
    icon: PropTypes.object,
    img: PropTypes.object,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    iconColor: PropTypes.oneOf([
        'primary',
        'warning',
        'danger',
        'success',
        'info',
        'rose',
        'gray',
    ]),
    vertical: PropTypes.bool,
};
export default withStyles(infoStyle)(InfoArea);
//# sourceMappingURL=InfoArea.js.map